export default preloadAssets;

/**
 * @param {Array<String>} urls array of urls.
 * @param {string} type source type(e.g. 'font', 'image')
 * @returns {Array<Promise>}
 */
function preloadAssets(urls, type) {
  return urls.map((url) => {
    return new Promise((resolve, reject) => {
      if (document.head.querySelector(`[href="${url}"]`)) {
        resolve();
      } else {
        const link = document.createElement('link');

        link.rel = 'preload';
        link.as = type;
        link.href = url;
        link.onload = () => resolve();
        link.onerror = () =>
          reject(new Error(`Can't preload ${type} (src: ${url})`));

        document.head.appendChild(link);
      }
    });
  });
}

export function preloadImages(urls) {
  // return preloadAssets(urls, 'image');
  const loads = urls.map((url) => PromisifyImage(url));

  return Promise.race([
    new Promise((_resolve, reject) => {
      setTimeout(reject, 10_000, new Error('preload timeout'));
    }),
    Promise.all(loads),
  ]).then(([, urls]) => urls);
}

export function PromisifyImage(src) {
  if (!src) {
    return Promise.resolve(src);
  }
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(src);
    image.onerror = () => {
      reject(new Error(`Preload asset failure`));
    };
    image.src = src;
  });
}
